import { useEffect } from "react";
import * as THREE from "three";
import { getSavedLightWorldPose } from "../../utils/savedLightWorldPose";
import { EMPTY_OBJECT, SAVED_LIGHT_MARKERS_GROUP_NAME } from "../scene/sceneConstants";
import { disposeSceneObjectTree } from "../scene/sceneDispose";
import { createSavedLightMarker } from "../scene/savedLightMarker";

export function useSavedLightMarkers({
  allSites,
  modelGroupRef,
  safeBodies,
  savedLights,
  sceneObjectsRef,
  sceneRef,
  structureChangeTick,
}) {
  useEffect(() => {
    const scene = sceneRef.current;
    if (!scene) return undefined;

    const removeMarkers = () => {
      const existing = scene.getObjectByName(SAVED_LIGHT_MARKERS_GROUP_NAME);
      if (!existing) return;
      existing.parent?.remove(existing);
      disposeSceneObjectTree(existing);
    };

    removeMarkers();
    const lights = Object.values(savedLights || EMPTY_OBJECT).filter(Boolean);
    if (lights.length === 0) return undefined;

    const root = new THREE.Group();
    root.name = SAVED_LIGHT_MARKERS_GROUP_NAME;
    root.userData = { isSavedLightMarkersRoot: true };
    scene.add(root);

    lights.forEach((lightDef) => {
      const marker = createSavedLightMarker(lightDef);
      const pose = getSavedLightWorldPose(
        lightDef,
        sceneObjectsRef.current,
        safeBodies,
        allSites || EMPTY_OBJECT,
        scene.getObjectByName("modelGroup") || modelGroupRef.current || null
      );
      marker.position.copy(pose.position);
      const source = new THREE.Vector3(0, 0, -1);
      const target = pose.direction.clone().normalize();
      marker.quaternion.setFromUnitVectors(source, target);
      root.add(marker);
    });

    return removeMarkers;
  }, [savedLights, safeBodies, allSites, structureChangeTick, sceneRef, sceneObjectsRef, modelGroupRef]);
}
